<!-- <p-selectButton [options]="panoramas" [(ngModel)]="selectedFile" optionLabel="name" (onChange)="showfile($event)"></p-selectButton> -->
<div style="background-color:antiquewhite;padding-left: 15px;">
    Wählen Sie einen panorama:  <p-dropdown [options]="panoramas" [(ngModel)]="selectedFile" optionLabel="name" (onChange)="showfile($event)" placeholder="Select panorama"></p-dropdown> 
</div>

<div #pano_container id="pano-container" style="width:100%;height:768px;">
</div>